import React, { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";

interface AppointmentActionBtnProps {
  action: "view_details" | "reject" | "confirm";
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  isDisabled?: boolean;
}

const AppointmentActionBtn: React.FC<AppointmentActionBtnProps> = ({
  action,
  onClick,
  isDisabled = false,
}) => {
  const { t } = useTranslation();

  const getButtonStyles = () => {
    if (isDisabled) {
      return "w-full bg-gray-300 text-gray-500 cursor-not-allowed opacity-60";
    }

    switch (action) {
      case "view_details":
        return "bg-primary-click w-[11.5rem] !text-primary";
      case "reject":
        return "w-[4.5rem] bg-error text-white";
      case "confirm":
        return "w-[6.5rem] bg-primary text-white";
      default:
        return "";
    }
  };

  return (
    <button
      type="button"
      onClick={isDisabled ? undefined : onClick}
      disabled={isDisabled}
      className={`rounded-lg py-1 flex items-center justify-center text-center text-sm font-bold transition-all duration-200 ${getButtonStyles()} ${
        isDisabled ? "hover:bg-gray-300" : "hover:opacity-80"
      }`}
    >
      {t(action)}
    </button>
  );
};

export default AppointmentActionBtn;
